import { useRef, useState } from "react";
import { Upload, X, Loader2 } from "lucide-react";
import api, { fileUrl } from "@/lib/api";
import { toast } from "sonner";

export function ImageUpload({ value, onChange, testId }) {
  const inputRef = useRef(null);
  const [loading, setLoading] = useState(false);

  const handleFile = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    if (!file.type.startsWith("image/")) {
      toast.error("Please select an image file");
      return;
    }
    setLoading(true);
    try {
      const form = new FormData();
      form.append("file", file);
      const { data } = await api.post("/upload", form, { headers: { "Content-Type": "multipart/form-data" } });
      onChange(data.url);
    } catch (err) {
      toast.error("Image upload failed");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div>
      <div
        onClick={() => !loading && inputRef.current?.click()}
        className="flex items-center justify-center gap-2 border-2 border-dashed border-slate-300 rounded-lg h-24 cursor-pointer hover:border-emerald-500 hover:bg-emerald-50/40 transition-colors"
        data-testid={testId ? `${testId}-dropzone` : undefined}
      >
        {loading ? (
          <Loader2 className="h-5 w-5 animate-spin text-emerald-600" />
        ) : (
          <>
            <Upload className="h-5 w-5 text-slate-400" />
            <span className="text-sm text-slate-500">{value ? "Replace image" : "Click to upload image"}</span>
          </>
        )}
        <input ref={inputRef} type="file" accept="image/*" capture="environment" className="hidden" onChange={handleFile} data-testid={testId} />
      </div>
      {value && (
        <div className="relative mt-3 inline-block">
          <img src={fileUrl(value)} alt="preview" className="h-32 w-auto rounded-lg border border-slate-200 object-cover" data-testid={testId ? `${testId}-preview` : undefined} />
          <button
            type="button"
            onClick={() => onChange("")}
            className="absolute -top-2 -right-2 bg-red-500 text-white rounded-full p-1 hover:bg-red-600 transition-colors"
            data-testid={testId ? `${testId}-remove` : undefined}
          >
            <X className="h-3 w-3" />
          </button>
        </div>
      )}
    </div>
  );
}
